<template>
  <v-row class="add-client-form ma-0">
    <div class="row mb-0 blue-underline margin-l-11">
      <v-col class="col-xl-2 col-md-2 cols-4 pt-1 pb-0" cols="4">
        <div class="col-md-12">
          <h3 class="form-title font col-md-12 pb-1 pt-1 font-18">
            Add New Providers
          </h3>
        </div>
      </v-col>
    </div>
    <div class="col-md-12 row no-padding mt-0 mb-0">
      <v-col
        cols="12"
        md="6"
        class="border-right pr-lg-10 pr-5 pt-0 pb-0 form-row-height"
      >
        <div class="mt-6 pl-2 pr-2 pb-4">
          <div class="row col-md-12">
            <h3 class="font">Search & Add Providers</h3>
          </div>
          <form class="row">
            <div class="col-md-12 no-padding">
              <div class="col-md-6 pb-0">
                <label class="font text-gray" for="">NPI Number</label>
                <v-text-field
                  required
                  v-model.trim="npiNumber"
                  :rules="npiRules"
                  solo
                ></v-text-field>
              </div>
            </div>

            <div class="col-md-6 pt-0 pb-0">
              <label class="font text-gray" for="">First Name</label>
              <v-text-field
                required
                v-model.trim="firstName"
                solo
              ></v-text-field>
            </div>
            <div class="col-md-6 pt-0 pb-0">
              <label class="font text-gray" for="">Last Name</label>
              <v-text-field
                required
                solo
                v-model.trim="lastName"
              ></v-text-field>
            </div>

            <div class="col-md-12"><h4>Narrow your Search</h4></div>
            <div class="col-md-12 pt-0 pb-0">
              <label class="text-gray font" for=""
                >Select Specialties (hold ctrl to select multiple)</label
              >
              <v-select
                multiple
                :items="taxonomies"
                required
                solo
                filled
                chips
                v-model.trim="speciality"
                :menu-props="{
                  bottom: true,
                  offsetY: true,
                  closeOnClick: true,
                  maxHeight: 200,
                }"
              >
                <template #selection="selection">
                  <v-chip
                    @click="deleteItem(selection.item)"
                    v-text="selection.item"
                  ></v-chip>
                </template>
              </v-select>
            </div>

            <!-- <div class="col-md-12 pt-0 pb-0">
              <label class="font text-gray" for="">Taxonomy / Speciality</label>
              <v-text-field
                required
                v-model.trim="speciality"
                solo
              ></v-text-field>
            </div> -->

            <div class="col-md-5 pt-0 pb-0">
              <label class="font text-gray" for="">City</label>
              <v-text-field required v-model.trim="city" solo></v-text-field>
            </div>
            <div class="col-md-5 pt-0 pb-0">
              <label class="font text-gray" for="">State</label>
              <v-select
                required
                item-text="name"
                item-value="value"
                :items="states"
                v-model.trim="state"
                solo
              ></v-select>
            </div>
            <div class="col-md-2 pt-0 pb-0">
              <label class="font text-gray" for="">Zip</label>
              <v-text-field required solo v-model.trim="zip" :rules="zipRules"></v-text-field>
            </div>
            <div class="col-md-12 text-end justify-end row">
              <v-progress-circular
                v-if="results"
                indeterminate
                color="primary mr-3"
              ></v-progress-circular>
              <div>
                <div @click="submit" class="text-gray text-underline pointer mt-1">
                  Search
                </div>
              </div>
            </div>
          </form>
        </div>
      </v-col>
      <v-col md="6" cols="12" class="justify-center align-center">
        <div class="row col-md-12 font mt-2 pb-4">
          <h3 class="ml-3">Upload List of Provider NPIs</h3>
        </div>
        <div class="row text-center justify-center upload-box">
          <div
            class="col-md-8 upload-dpc-provider-box pointer"
            @click="addItemExcel"
          >
            <input
              ref="fileInput"
              type="file"
              style="display: none"
              @change="uploadExcel"
            />
            <svg
              width="100"
              height="100"
              viewBox="0 0 100 100"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M90.2135 56.7407C86.921 54.5225 83.1435 53.1493 79.208 52.7403C75.2726 52.3313 71.2979 52.8986 67.6281 54.3933C63.9583 55.8879 60.704 58.2648 58.147 61.3181C55.5901 64.3713 53.8075 68.009 52.9537 71.916C51.4417 76.8915 51.7658 82.2529 53.8659 87.005C55.9661 91.7571 59.6995 95.5771 64.3734 97.7561C66.9118 98.6879 69.5174 99.4207 72.1671 99.9481C72.3424 99.9983 72.5259 100.012 72.7065 99.9875C72.8871 99.9632 73.0608 99.9018 73.217 99.807C73.3732 99.7122 73.5086 99.586 73.6147 99.4363C73.7209 99.2866 73.7956 99.1164 73.8342 98.9364C74.4177 96.618 70.8751 97.3346 65.4987 94.9318C61.6722 92.939 58.6871 89.614 57.094 85.5701C55.5008 81.5262 55.4069 77.0361 56.8297 72.9277C57.619 69.7482 59.1452 66.8043 61.2821 64.3395C63.419 61.8746 66.1053 59.9597 69.1189 58.7528C72.1325 57.546 75.3868 57.082 78.6128 57.3991C81.8388 57.7163 84.9438 58.8055 87.6712 60.5767C91.3984 63.1517 94.1367 66.9448 95.4268 71.3196C96.7168 75.6945 96.4801 80.3849 94.7564 84.6042C92.5892 89.9577 87.046 96.5758 81.1695 96.8287C79.169 96.8287 78.9606 101.339 86.0458 98.2619C91.2017 95.6067 95.3368 91.2909 97.7989 85.9953C100.112 80.9907 100.62 75.325 99.2345 69.9813C97.8489 64.6375 94.6573 59.953 90.2135 56.7407V56.7407Z"
                fill="#4072B7"
              />
              <path
                d="M79.1678 70.3161C81.2871 72.781 82.902 75.6465 83.919 78.7468C83.919 79.1158 84.0639 79.4696 84.3219 79.7305C84.5798 79.9913 84.9296 80.1379 85.2944 80.1379C85.6592 80.1379 86.009 79.9913 86.2669 79.7305C86.5249 79.4696 86.6698 79.1158 86.6698 78.7468C86.3859 76.2974 85.725 73.9079 84.7109 71.665C84.2108 70.6112 83.7106 69.726 83.0021 68.2928C82.4951 67.1647 81.7563 66.1588 80.8349 65.342C78.5843 63.7823 75.2501 65.342 73.2912 67.1125C70.7302 69.9395 68.7974 73.2885 67.6231 76.9342C67.543 77.0833 67.4946 77.2475 67.4807 77.4165C67.4668 77.5855 67.4879 77.7556 67.5425 77.916C67.5972 78.0763 67.6842 78.2234 67.7981 78.3479C67.912 78.4723 68.0502 78.5715 68.2041 78.639C68.3579 78.7065 68.5239 78.7409 68.6916 78.74C68.8593 78.7391 69.0249 78.703 69.178 78.6338C69.3311 78.5647 69.4683 78.464 69.5809 78.3384C69.6935 78.2127 69.779 78.0647 69.832 77.9038C71.1592 75.4585 72.9097 73.274 75 71.4543C75 72.5081 75 73.857 75 74.1521C74.3604 77.4976 74.192 80.9179 74.4999 84.3111C74.4375 86.1337 74.5773 87.9577 74.9167 89.7489C74.9774 90.0675 75.1609 90.3487 75.4266 90.5305C75.6924 90.7123 76.0187 90.7799 76.3337 90.7184C76.6487 90.6569 76.9267 90.4714 77.1065 90.2026C77.2862 89.9338 77.3531 89.6038 77.2923 89.2852C77.4945 87.7059 77.8576 86.152 78.3759 84.6483C79.1199 81.2736 79.289 77.7952 78.876 74.3629C78.4593 67.4919 78.2925 69.0515 79.1678 70.3161Z"
                fill="#4072B7"
              />
              <path
                d="M20.1537 21.7534C22.1876 22.4505 24.2802 22.9584 26.4053 23.2709C30.5503 23.8942 34.7637 23.8942 38.9086 23.2709C39.2734 23.2709 39.6232 23.1243 39.8812 22.8635C40.1391 22.6026 40.284 22.2488 40.284 21.8798C40.284 21.5109 40.1391 21.1571 39.8812 20.8962C39.6232 20.6353 39.2734 20.4888 38.9086 20.4888C34.8425 19.3343 30.627 18.8085 26.4053 18.9291C24.138 18.6979 21.848 18.898 19.6535 19.5192C19.1951 19.8565 18.9867 21.0368 20.1537 21.7534Z"
                fill="#4072B7"
              />
              <path
                d="M18.8224 38.1526C18.7239 38.4172 18.7159 38.7074 18.7996 38.9771C18.8833 39.2467 19.0539 39.4803 19.2842 39.6404C19.5144 39.8005 19.7911 39.878 20.07 39.8605C20.3489 39.8429 20.614 39.7314 20.8229 39.5437C24.7935 39.4649 28.7642 39.6904 32.7011 40.2182C42.5787 40.4711 49.3721 39.1643 56.7074 38.785C57.0364 38.7273 57.3346 38.554 57.5495 38.2956C57.7645 38.0373 57.8823 37.7105 57.8823 37.3728C57.8823 37.0352 57.7645 36.7084 57.5495 36.45C57.3346 36.1917 57.0364 36.0184 56.7074 35.9607C47.2075 35.1589 37.6581 35.1589 28.1582 35.9607C26.4077 36.2557 20.1561 35.9185 18.8224 38.1526Z"
                fill="#4072B7"
              />
              <path
                d="M43.9089 54.7602C37.0909 53.4732 30.0964 53.4732 23.2784 54.7602C19.9442 55.3082 19.4857 55.266 19.1106 55.6876C18.9082 55.837 18.7549 56.0446 18.6706 56.2833C18.5862 56.522 18.5748 56.7808 18.6377 57.0262C18.7006 57.2716 18.8349 57.4922 19.0233 57.6594C19.2117 57.8266 19.4454 57.9327 19.6941 57.9638C20.2352 58.0036 20.7785 58.0036 21.3195 57.9638C28.8509 59.0779 36.5025 59.0779 44.0339 57.9638C44.2419 57.9555 44.4462 57.9059 44.6352 57.8177C44.8242 57.7295 44.9942 57.6046 45.1355 57.45C45.2767 57.2954 45.3865 57.1141 45.4585 56.9166C45.5305 56.7191 45.5633 56.5091 45.5551 56.2988C45.5469 56.0884 45.4978 55.8818 45.4106 55.6906C45.3235 55.4994 45.1999 55.3275 45.0471 55.1846C44.8942 55.0418 44.715 54.9307 44.5197 54.8579C44.3244 54.7851 44.1168 54.7519 43.9089 54.7602V54.7602Z"
                fill="#4072B7"
              />
              <path
                d="M41.2847 72.8444C29.5732 72.8444 16.8199 71.2847 5.10843 69.9358C11.1934 54.6341 10.5682 32.7985 12.4854 8.39167C12.4854 7.97014 13.3189 6.62123 13.694 6.53692C17.8618 5.56739 37.4503 2.82741 39.9927 2.70095C41.8441 2.55245 43.7069 2.738 45.4941 3.24895C47.0362 3.62833 49.9953 -0.123332 39.7843 0.0031284C37.492 0.0452819 15.5278 1.98434 12.0686 2.91172C8.60935 3.8391 8.526 6.19969 7.48406 15.5578C5.5252 43.6741 5.35849 50.9667 3.31629 60.9149C1.27408 70.8632 -0.684772 71.0739 0.232138 72.6336C0.388726 72.9446 0.619216 73.2114 0.902917 73.41C1.18662 73.6087 1.51465 73.733 1.85757 73.7717C14.1525 74.7413 28.9064 75.9216 41.2847 75.6686C41.6136 75.611 41.9118 75.4377 42.1268 75.1793C42.3417 74.921 42.4596 74.5942 42.4596 74.2565C42.4596 73.9189 42.3417 73.5921 42.1268 73.3337C41.9118 73.0754 41.6136 72.9021 41.2847 72.8444V72.8444Z"
                fill="#4072B7"
              />
              <path
                d="M61.7465 13.1549C63.2469 14.5881 65.9143 16.4007 66.6228 17.9604L66.206 44.2642C66.2591 44.5548 66.4112 44.8173 66.6358 45.0064C66.8604 45.1954 67.1433 45.2989 67.4355 45.2989C67.7277 45.2989 68.0106 45.1954 68.2352 45.0064C68.4598 44.8173 68.6119 44.5548 68.665 44.2642C68.665 41.9879 72.8328 20.1524 70.7906 15.8527C69.3318 12.9863 69.0401 13.9558 54.703 1.77345C54.4073 1.58391 54.0527 1.51177 53.7076 1.57094C53.3625 1.6301 53.0512 1.81637 52.8338 2.09386C52.6164 2.37135 52.5082 2.72041 52.5301 3.07376C52.5521 3.42712 52.7025 3.75977 52.9525 4.00759L61.7465 13.1549Z"
                fill="#4072B7"
              />
              <path
                d="M47.0348 21.3321C49.202 25.5474 56.704 23.777 61.4553 22.4702C69.7908 20.1939 65.623 16.0629 63.9559 18.2549C59.8192 19.6492 55.394 19.9253 51.1192 19.0558C50.7664 16.162 50.879 13.2296 51.4526 10.3722C51.7861 5.77745 51.8277 5.86176 51.0775 5.60884C49.4938 4.93439 49.077 7.4636 48.4518 9.82419C47.6183 12.9435 45.1176 17.4961 47.0348 21.3321Z"
                fill="#4072B7"
              />
              <path
                d="M73.4197 8.47638C75.5477 10.1898 77.4772 12.1413 79.1712 14.2936L76.7123 45.1499C76.7123 46.7939 77.8376 47.4684 78.7128 46.1194C79.9631 42.3678 85.0061 15.1366 82.2971 11.2585C78.8507 7.41849 74.8788 4.09688 70.5023 1.3946C70.367 1.25149 70.2031 1.13924 70.0215 1.06535C69.8399 0.991459 69.6447 0.95763 69.4492 0.966125C69.2536 0.974619 69.0621 1.02524 68.8874 1.11461C68.7127 1.20397 68.5589 1.33002 68.4363 1.48433C68.3136 1.63864 68.2249 1.81765 68.1762 2.00939C68.1274 2.20114 68.1197 2.40121 68.1535 2.59622C68.1873 2.79123 68.2619 2.9767 68.3723 3.14022C68.4826 3.30374 68.6262 3.44154 68.7935 3.54442L73.4197 8.47638Z"
                fill="#F6A405"
              />
            </svg>

            <h3 class="text-gray font">Drag & Drop</h3>
            <h5 class="text-gray font">
              Your files here or
              <a>Browse</a>
              to upload
            </h5>
            <h5 class="text-gray font">
              <a>Excel or CSV files Only</a> <br />
              <img
                v-if="arrayLength"
                src="/success.png"
                width="30"
                height="30"
                alt=""
              />
            </h5>
          </div>
          <div class="btn-box col-md-9">
            <div class="downoald-file-btn-box">
              <h3>
                <a class="underline-text" @click="downloadExcel"
                  >Download File Template</a
                >
              </h3>
            </div>
          </div>
        </div>
      </v-col>
      <errorModal ref="error_modal" v-on:confirm="closeErrorModal"></errorModal>
    </div>

    <div class="row gray-underline-wizard margin-l-11 mt-0 pr-12">
      <div class="col-md-12 row text-end mt-3 mb-3 justify-end">
        <span
          class="text-underline pointer mr-10"
          style="color:#0572F3;"
          @click="$router.go(-1)"
          >Cancel</span
        >
        <span class="text-underline pointer mr-2" 
        style="color:#0572F3;"
        @click="submit"
          >Process</span
        >
      </div>
    </div>
    <v-dialog
    v-if="cityMissing"
        hide-overlay
        v-model.trim="cityMissing"
        height="320"
        width="400"
        style="margin-top:30vh;"
        content-class="modal-member-check"
      >
        <v-card>
          <v-card-text>
            <div class="col-md-12 pt-10 text-center" @click="cityMissing = false">
              <div class="red-error-modal">
              
                <svg
                  class="mt-3"
                  width="37"
                  height="37"
                  viewBox="0 0 54 54"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M23.7713 5.74543C24.1794 6.19751 24.6778 6.55892 25.2344 6.80627C25.7909 7.05363 26.3931 7.18144 27.0021 7.18144C27.6111 7.18144 28.2133 7.05363 28.7698 6.80627C29.3263 6.55892 29.8248 6.19751 30.2329 5.74543L32.3216 3.42968C32.9244 2.76457 33.718 2.30209 34.5938 2.10559C35.4696 1.90908 36.3847 1.98815 37.2138 2.33198C38.0429 2.6758 38.7455 3.26755 39.2253 4.02621C39.7052 4.78487 39.9388 5.67334 39.8942 6.56994L39.7342 9.68131C39.7033 10.2898 39.8003 10.898 40.0191 11.4667C40.2378 12.0353 40.5734 12.5518 41.0042 12.9826C41.435 13.4134 41.9513 13.7491 42.5198 13.9679C43.0884 14.1867 43.6965 14.2837 44.3049 14.2528L47.4157 14.0928C48.3145 14.0449 49.2061 14.2769 49.9676 14.7569C50.7291 15.2368 51.3231 15.941 51.6679 16.7725C52.0127 17.6041 52.0913 18.5221 51.8929 19.4002C51.6945 20.2783 51.2287 21.0732 50.5599 21.6756L48.2445 23.7647C47.7925 24.1729 47.4312 24.6714 47.1839 25.228C46.9366 25.7847 46.8088 26.387 46.8088 26.9961C46.8088 27.6052 46.9366 28.2075 47.1839 28.7641C47.4312 29.3208 47.7925 29.8193 48.2445 30.2275L50.5599 32.3165C51.2275 32.9189 51.6922 33.7132 51.8902 34.5904C52.0882 35.4676 52.0098 36.3846 51.6657 37.2155C51.3216 38.0463 50.7287 38.7501 49.9685 39.2303C49.2083 39.7105 48.3181 39.9435 47.4202 39.8972L44.3094 39.7372C43.701 39.7066 43.0931 39.8039 42.5247 40.0228C41.9563 40.2417 41.4401 40.5774 41.0094 41.0081C40.5787 41.4389 40.2431 41.9552 40.0243 42.5237C39.8054 43.0922 39.7081 43.7002 39.7387 44.3087L39.8987 47.42C39.9449 48.3181 39.712 49.2085 39.2319 49.9688C38.7518 50.7292 38.0481 51.3222 37.2174 51.6663C36.3867 52.0105 35.4699 52.0889 34.5929 51.8909C33.7158 51.6928 32.9216 51.228 32.3194 50.5603L30.2307 48.2445C29.8225 47.7925 29.3241 47.431 28.7676 47.1837C28.2111 46.9363 27.6089 46.8085 26.9999 46.8085C26.3909 46.8085 25.7886 46.9363 25.2321 47.1837C24.6756 47.431 24.1772 47.7925 23.7691 48.2445L21.6737 50.5625C21.0714 51.2302 20.2772 51.6951 19.4002 51.8931C18.5232 52.0912 17.6063 52.0127 16.7757 51.6685C15.945 51.3244 15.2413 50.7314 14.7612 49.971C14.2811 49.2107 14.0481 48.3203 14.0944 47.4222L14.2544 44.3109C14.2853 43.7024 14.1883 43.0941 13.9695 42.5255C13.7508 41.9568 13.4152 41.4404 12.9844 41.0096C12.5537 40.5787 12.0373 40.2431 11.4688 40.0243C10.9002 39.8055 10.2921 39.7084 9.68371 39.7394L6.57289 39.8994C5.67751 39.9419 4.79083 39.707 4.03398 39.2266C3.27713 38.7462 2.687 38.0439 2.34423 37.2155C2.00145 36.3871 1.92273 35.473 2.11883 34.5982C2.31492 33.7233 2.77627 32.9304 3.43985 32.3277L5.75519 30.2386C6.20719 29.8304 6.56853 29.3319 6.81585 28.7753C7.06316 28.2186 7.19095 27.6163 7.19095 27.0072C7.19095 26.3981 7.06316 25.7958 6.81585 25.2392C6.56853 24.6825 6.20719 24.184 5.75519 23.7758L3.43985 21.6868C2.77136 21.0846 2.30584 20.2901 2.10731 19.4124C1.90878 18.5348 1.98701 17.6172 2.33123 16.7859C2.67544 15.9546 3.26874 15.2503 4.0295 14.7701C4.79027 14.2898 5.68113 14.0571 6.57955 14.1039L9.69037 14.2639C10.2999 14.296 10.9094 14.1994 11.4792 13.9805C12.0489 13.7616 12.5663 13.4252 12.9976 12.9932C13.4289 12.5612 13.7644 12.0432 13.9825 11.473C14.2006 10.9028 14.2962 10.2931 14.2633 9.68353L14.1033 6.57216C14.0603 5.67644 14.2948 4.78927 14.7749 4.03191C15.255 3.27455 15.9573 2.68395 16.7856 2.34082C17.614 1.99769 18.5281 1.91878 19.403 2.11487C20.2779 2.31095 21.0709 2.77247 21.6737 3.43634L23.7713 5.74543Z"
                    stroke="#E40000"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M34 21L19 36"
                    stroke="#E40000"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M19 21L34 36"
                    stroke="#E40000"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <div class="error-modal-red-text">
                  Please choose a city first
                </div>
          
              </div>
            </div>

          </v-card-text>
        </v-card>
      </v-dialog>
  </v-row>
</template>
<script>
import api from "../../../../../services/api";
import XLSX from "xlsx";
import errorModal from "../../../../TablesTemplate/ErrorDialog.vue";
export default {
  components: { errorModal },
  data() {
    return {
      cityMissing: false,
      npiNumber: "",
      npiType: "",
      firstName: "",
      lastName: "",
      organizationName: "",
      speciality:null,
      city: "",
      state: "",
      zip: "",
      states: [],
      excelError: false,
      results: false,
      arrayLength: false,
      urlData: "",
      taxonomies: [],
      taxonomiesValue: "",
      excelError: false,
      jsondata: [
        {
          NPI: "",
        },
      ],
      zipRules: [
        (v) => (v && v.length == 5) || " Zip Code should be five digits long",
      ],
      npiRules: [
      (v) => !!v || "This field is required",
        (v) => (v && v.length == 10) || "NPI Number should be 10 digits long",
      ],
    };
  },
  computed: {
    route() {
      return this.$route.path;
    },
    getClient() {
      return this.$store.getters.getClientGetter;
    },
    routeParams() {
      return this.$route.params.name;
    },
  },
  created() {
    this.getAllProviders();
    this.getStates();
    this.arrayExcel = [];
    this.taxonomies = this.$store.getters.getTaxonomies;
  },
  methods: {
    deleteItem(item) {
      this.speciality = this.speciality.filter((find) => find !== item);
    },
    closeErrorModal() {
      this.$refs.error_modal.closePopUp();
    },

    downloadExcel() {
      const data = XLSX.utils.json_to_sheet(this.jsondata);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, "data");
      XLSX.writeFile(wb, "providerList.xlsx");
    },
    getStates() {
      api()
        .get("/api/states")
        .then((res) => {
          res.data.forEach((el) => {
            if (el.active) {
              this.states.push(el);
            }
          });
        });
    },
    addItemExcel() {
      this.$refs.fileInput.click();
    },
   uploadExcel(e) {
      this.excelError = false;
      const files = e.target.files;
      if (!files.length) {
        return;
      } else if (!/\.(xls|xlsx|csv)$/.test(files[0].name.toLowerCase())) {
        return alert(
          "The upload format is incorrect. Please upload xls, xlsx or csv format"
        );
      }
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary",
          });
          const wsname = workbook.SheetNames[0];
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]);
          const excellist = [];

          for (var i = 0; i < ws.length; i++) {
            if (ws[i].NPI) {
              excellist.push(ws[i].NPI);
              this.excelError = false;
              this.arrayExcel.push(ws[i].NPI);
              this.arrayLength = true;
            } else {
              this.excelError = true;
              this.arrayLength = false;
            }
          }
          if (this.arrayExcel.length < 1) {
            this.arrayLength = false;
            this.$refs.error_modal.openPopUp(
              "Something Went Wrong, Please Download The File Template First"
            );
          }
          this.submit()
        } catch (e) {
          return alert("Read failure! Please Download the File Template.");
        }
      };
      fileReader.readAsBinaryString(files[0]);

      
    },
    getAllProviders() {
      api()
        .get(`/dpcproviders/providers`)
        .then((res) => {
          if (res) {
          this.allProviders = res.data;
       
          }
        })
        
    },
    submit() {
      // T.N. disabled this because it's restricting us to search providers
    if(false && (this.state || this.state!= null ) &&  (this.city == null || this.city == undefined || !this.city)){
      this.cityMissing = true;
     }
     else
     {
      this.results = true;
      let urlData = {
      
      };

      if (this.npiNumber) {
       urlData.number = this.npiNumber;
      }
      if (this.firstName) {
        urlData.first_name = this.firstName;
      }
      if (this.lastName) {
        urlData.last_name = this.lastName;
      }
      if (this.state) {
        urlData.state = this.state;
      }
      if (this.city) {
        urlData.city = this.city;
      }
      if (this.zip) {
        urlData.postal_code = this.zip;
      }
      if (this.speciality) {
        urlData.taxonomy_description = this.speciality;
      }

      if (this.arrayExcel.length != 0) {
        urlData = {
          npis: this.arrayExcel,
        };
      }
      console.log('urlDAta',urlData)
      api()
        .post(`/dpcproviders/providers/search`, urlData)
        .catch((err) => {
          if(err){
            this.results = false;
              if (err.response.status == 500) {
                    this.$refs.error_modal.openPopUp(
                      "There was an error, system admin is notified. Please try again later."
                    );}
                   else{
                    this.$refs.error_modal.openPopUp(err.response.data[0].description)
                   }
                  
          }
                
                })
        .then((res) => {
          if (res) {
            this.results = false;
            this.$router.push(`/dpc-providers/providers/search-result`);
            const filteredArray1 = res.data.filter(item1 => !this.allProviders.some(item2 =>  item1.number === item2.NPI));
            this.$store.commit("setSearchResultProviders", filteredArray1);
            this.$store.commit("isSearchIsFromMember", false);
            this.$store.commit("setUrlData", urlData);
          }
        });
     }
    
    },
  },
};
</script>
